import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { DashboardLayout } from '../../components/Layout';
import api from '../../services/api';
import GuestDashboard from './GuestDashboard';
import PublicWebInvitePage from '../public/PublicWebInvitePage';

export default function GuestHomeRoute() {
  const { currentEvent } = useAuth();
  const [entry, setEntry] = useState({ status: 'checking', slug: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!currentEvent?.id || !['wedding', 'birthday'].includes(currentEvent.event_type || 'wedding')) {
      setEntry({ status: 'legacy', eventId: currentEvent?.id });
      return undefined;
    }

    const controller = new AbortController();
    const eventId = currentEvent.id;
    setEntry({ status: 'checking', eventId });
    api.get(`/events/${currentEvent.id}/web-invite/guest-entry`, { signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        if (response.data?.active && response.data?.slug) {
          setEntry({ status: 'invite', eventId, slug: response.data.slug });
        } else if (response.data?.default_invite) {
          setEntry({ status: 'default', eventId, invite: response.data.default_invite });
        } else {
          setEntry({ status: 'error', eventId });
        }
      })
      .catch((error) => {
        if (!controller.signal.aborted && error.code !== 'ERR_CANCELED') {
          setEntry({ status: 'error', eventId });
        }
      });

    return () => controller.abort();
  }, [currentEvent?.id, currentEvent?.event_type, attempt]);

  if (entry.status === 'checking' || entry.eventId !== currentEvent?.id || entry.status === 'error') {
    return (
      <DashboardLayout>
        <div className="grid min-h-[55vh] place-items-center">
          <div className="text-center">
            {entry.status === 'error' ? <>
              <p className="text-sm text-muted-foreground">Could not open your event home. Please try again.</p>
              <button className="mt-4 rounded-md border px-4 py-2 text-sm" onClick={() => setAttempt((value) => value + 1)}>Try again</button>
            </> : <>
              <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-primary/20 border-t-primary" />
              <p className="mt-4 text-sm text-muted-foreground">Opening event home…</p>
            </>}
          </div>
        </div>
      </DashboardLayout>
    );
  }

  if (entry.status === 'invite') {
    return <Navigate to={`/e/${entry.slug}`} replace state={{ fromGuestHome: true }} />;
  }

  if (entry.status === 'default') return <PublicWebInvitePage key={entry.eventId} guestInvite={entry.invite} />;

  return <GuestDashboard />;
}
